import React from 'react';

/* Match-score ring. Ported from `ScoreGauge` in MatchDetailSheet.swift:
   52px, 5.5px stroke, arc starts at 12 o'clock.

   Callers must not render this for a school outside the athlete's match set —
   a search-opened school synthesizes score 0, and an empty ring would read as
   "this school scored zero for you", which is false. MatchDetailModal gates on
   the same `score != 0 || reasons.length` condition the apps use. */

const SIZE = 52;
const STROKE = 5.5;
const R = (SIZE - STROKE) / 2;
const CIRC = 2 * Math.PI * R;

export default function ScoreGauge({ score }) {
  const frac = Math.min(Math.max(score / 100, 0), 1);
  return (
    <div className="sd-gauge" role="img" aria-label={`Match score ${score}`}>
      <svg width={SIZE} height={SIZE} aria-hidden="true">
        <circle
          cx={SIZE / 2} cy={SIZE / 2} r={R} fill="none"
          stroke="var(--sd-track)" strokeWidth={STROKE}
        />
        <circle
          cx={SIZE / 2} cy={SIZE / 2} r={R} fill="none"
          stroke="var(--sd-purple)" strokeWidth={STROKE} strokeLinecap="round"
          strokeDasharray={`${(CIRC * frac).toFixed(2)} ${CIRC.toFixed(2)}`}
          transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
        />
      </svg>
      <span className="sd-gauge__num" aria-hidden="true">{score}</span>
    </div>
  );
}
